import { graphql } from "msw";
import { range } from "ramda";
import { getFaker } from "Apimocks/utils/getFaker";

let allUsers;

const adminGroup = {
    id: "admin",
    name: "ADMINISTRATOR",
};
const collabGroup = {
    id: "admin",
    name: "COLLABORATOR",
};
const reviewerGroup = {
    id: "admin",
    name: "REVIEWER",
};
const adminGroupDisabled = {
    id: "admin",
    name: "ADMINISTRATOR-DISABLED",
};
const collabGroupDisabled = {
    id: "admin",
    name: "COLLABORATOR-DISABLED",
};
const reviewerGroupDisabled = {
    id: "admin",
    name: "REVIEWER-DISABLED",
};

export const getUsers = async () => {
    if (allUsers) return allUsers;
    const faker = await getFaker();
    faker.seed(1);
    // eslint-disable-next-line no-magic-numbers
    const users = range(0, 30).map(i => ({
        node: {
            _id: `${i}`,
            email: faker.internet.email(),
            firstname: faker.name.firstName(),
            groups: [
                faker.helpers.randomize([
                    adminGroup,
                    collabGroup,
                    reviewerGroup,
                    adminGroupDisabled,
                    collabGroupDisabled,
                    reviewerGroupDisabled, 
                ])
            ],
            lastname: faker.name.lastName(),
        }
    }));

    // eslint-disable-next-line require-atomic-updates
    allUsers = users;
    return users;
};

export const handlers = [
    graphql.query("loadAllUsersInProject", async (req, res, ctx) => {
        const users = await getUsers();
        return res(
            ctx.delay(),
            ctx.data({
                currentProject: {
                    __typename: "Project",
                    availableusers: {
                        edges: users.map(user => ({
                            node: user,
                        })),
                    },
                },
            })
        );
    }),
    graphql.query("userById", async (req, res, ctx) => {
        const { id } = req.variables;
        const users = await getUsers();
        const user = users.find(({ _id: uid }) => uid === id);
        return res(ctx.delay(), ctx.data({ userById: user }));
    }),
    graphql.query("LoadAssignableUsersQuery", async (req, res, ctx) => {
        const users = await getUsers();
        return res(ctx.delay(), ctx.data(users));
    }),
    graphql.mutation("createUserInProject", async (req, res, ctx) => {
        const { newUser } = req.variables;
        if (!allUsers) await getUsers();
        const fullNewUser = {
            ...newUser,
            _id: `${allUsers.length + 1}`,
            groups: [],
            roles: [newUser.role],
            status: "Activated",
        };
        allUsers.push(fullNewUser);
        res(
            ctx.delay(),
            ctx.data({
                createUserInProject: fullNewUser,
            })
        );
    }),
    graphql.mutation("editUser", async (req, res, ctx) => {
        const { modifications, userId } = req.variables;
        if (!allUsers) await getUsers();
        const user = allUsers.find(({ _id }) => _id === userId);
        const updatedUser = Object.assign(user, modifications);
        res(
            ctx.delay(),
            ctx.data({
                editUser: updatedUser,
            })
        );
    }),
    graphql.mutation("editUsers", async (req, res, ctx) => {
        const { modifications } = req.variables;
        if (!allUsers) await getUsers();
        const updates = modifications.map(
            ({ modifications: xmods, userId }) => {
                const user = allUsers.find(({ _id }) => _id === userId);
                const updatedUser = Object.assign(user, xmods);
                return updatedUser;
            }
        );
        res(
            ctx.delay(),
            ctx.data({
                editUsers: updates,
            })
        );
    }),
];
